module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAWlBMVEUAAAD8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB8OvH/4AAAAHXRSTlMA+psR6qJcKvftypEL1zUbDq8XLSjOd0bFj2hYJ8C9kCgAAADYSURBVDjLhZPZjsIwDEVPszRd6M7AbP7/3xxpQBC7lJw3R1Z8fW3zZK5dF6oqdK6e2XOOjTxo4hnNqa9EUfUnMqYP2TEkHoxBXtCO3EmtvKRN9/qDHDDcdPRySP/fX65/8avLe0lAlIwVfB5H8I1kzCah8dSS8wubeqhxKh7hqh4cnYqvmC87tIk/cNFmoYf0DV96aCbhAtEkBKOJT13CiAzrKEakk7c409UyTYs2yljtYdVWG9XTflikSpXwdtzlhSmvHNvR0m6ltS8dTvH0NEkfb0JzfP5/c3lSKwpBFzEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_yellow/remind.png
// module id = R3hu
// module chunks = 1